import { useEffect, useState } from "react";
import http from "@/lib/api";
import { Panel, Table, Td, Empty, fmt } from "./AdminKit";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Plus, Trash2, Pencil } from "lucide-react";
import SmsButton from "./SmsButton";

const empty = { name: "", phone: "", email: "", company: "", address: "", internal_notes: "" };

export default function AdminCustomers() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = () => http.get("/v1/admin/customers").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.name.trim()) { toast.error("Имя обязательно"); return; }
    try {
      if (editId) await http.put(`/v1/admin/customers/${editId}`, form);
      else await http.post("/v1/admin/customers", form);
      toast.success("Сохранено"); setOpen(false); setForm(empty); setEditId(null); load();
    } catch { toast.error("Ошибка"); }
  };

  const edit = (r) => { setForm({ name: r.name, phone: r.phone || "", email: r.email || "", company: r.company || "", address: r.address || "", internal_notes: r.internal_notes || "" }); setEditId(r.id); setOpen(true); };
  const remove = async (id) => { if (!window.confirm("Удалить клиента?")) return; try { await http.delete(`/v1/admin/customers/${id}`); toast.success("Удалено"); load(); } catch { toast.error("Ошибка"); } };

  const field = (k, label) => <div><label className="text-sm text-slate-300">{label}</label><Input value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="mt-1 bg-slate-700 border-slate-600 text-white" /></div>;

  return (
    <div className="space-y-6" data-testid="admin-customers">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-white">Клиенты</h1>
        <Button className="bg-blue-600 hover:bg-blue-700 text-white gap-2" onClick={() => { setForm(empty); setEditId(null); setOpen(true); }} data-testid="customer-add"><Plus className="h-4 w-4" />Новый клиент</Button>
      </div>
      <Panel title={`Всего: ${rows.length}`}>
        {rows.length === 0 ? <Empty /> : (
          <Table head={["Код", "Имя", "Телефон", "E-mail", "Компания", "Создан", "Действия"]}>
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-slate-700/50">
                <Td>{r.customer_code || "-"}</Td>
                <Td>{r.name}</Td>
                <Td>{r.phone || "-"}</Td>
                <Td>{r.email || "-"}</Td>
                <Td>{r.company || "-"}</Td>
                <Td>{fmt(r.created_at)}</Td>
                <Td>
                  <div className="flex gap-2 items-center">
                    <SmsButton phone={r.phone} name={r.name} tid={r.id} />
                    <button onClick={() => edit(r)} className="text-blue-400 hover:text-blue-300" data-testid={`customer-edit-${r.id}`}><Pencil className="h-4 w-4" /></button>
                    <button onClick={() => remove(r.id)} className="text-red-400 hover:text-red-300"><Trash2 className="h-4 w-4" /></button>
                  </div>
                </Td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-slate-800 border-slate-700 text-white">
          <DialogHeader><DialogTitle>{editId ? "Редактировать клиента" : "Новый клиент"}</DialogTitle></DialogHeader>
          <div className="space-y-3">
            {field("name", "Имя *")}
            <div className="grid grid-cols-2 gap-3">{field("phone", "Телефон")}{field("email", "E-mail")}</div>
            {field("company", "Компания")}
            {field("address", "Адрес")}
            {field("internal_notes", "Внутренние заметки")}
          </div>
          <DialogFooter><Button className="bg-blue-600 hover:bg-blue-700 text-white" onClick={save} data-testid="customer-save">Сохранить</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
